import styled from 'styled-components';

import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';

export const Loading = styled.div`
  text-align: center;
  margin-top: 200px;
  margin-bottom: 200px;
`;

export const NoDataTitle = styled(Typography)`
  font-weight: 400;
  color: #333;
  opacity: 0.6;
  text-align: center;
  margin-top: 20px !important;
`;

export const ContactList = styled(List)`
  max-width: 85%;
  max-height: 400px;
  position: relative;
  overflow: auto;
  padding: 0px;

  > div:first-child {
    margin: 0;
    width: 100%;

    div {
      width: 80%;
    }
  }
`;

export const ListChild = styled(ListItem)`
  border-bottom: 1px solid #ccc;
`;

export const BackButton = styled(Button).attrs({
  variant: 'text',
})`
  color: #e8e6e3;
  background-color: #fff;
  border: 0px;
  font-weight: bold !important;
  font-size: 20px !important;
`;
